import { render, staticRenderFns } from "./AssignmentPreview.vue?vue&type=template&id=67ec1ec6&scoped=true&"
import script from "./AssignmentPreview.vue?vue&type=script&lang=js&"
export * from "./AssignmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPreview.vue?vue&type=style&index=0&id=67ec1ec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec1ec6",
  null
  
)

export default component.exports